import { render } from "./VideoInfo.vue?vue&type=template&id=58a193b6&scoped=true"
import script from "./VideoInfo.vue?vue&type=script&lang=js"
export * from "./VideoInfo.vue?vue&type=script&lang=js"

import "./VideoInfo.vue?vue&type=style&index=0&id=58a193b6&scoped=true&lang=css"

import exportComponent from "/home/runner/work/acp-portal-frontend/acp-portal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58a193b6"]])

export default __exports__